module.exports = __webpack_public_path__ + "static/img/product11-1.a6f0d6ae.png";